<template>
  <div class="content-wrapper">
    <!-- Page Loader -->
    <div class="vld-parent">
      <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
    </div>

    <breadcrumb :page="$t('transcript.fullTranscript')"></breadcrumb>

    <div class="content">
      <div class="container-fluid">
        <back-button></back-button>

        <hr />

        <b-alert v-model="alert" :variant="alertClass" dismissible fade>{{
          alertMessage
        }}</b-alert>

        <div class="row">
          <div class="col-10 mx-auto">
            <download-transcript
              :id="$route.params.id"
              type="full"
              v-if="downloadBtns"
            >
            </download-transcript>

            <div
              class="card"
              style="
                max-width: 820px;
                min-height: 760px;
                margin: 15px auto;
                padding: 100px 40px;
              "
            >
              <div class="card-body">
                <top
                  :student="student"
                  :program="program"
                  :report_date="report_date"
                  :academic_year="program.academic_year"
                ></top>

                <div v-if="program.program_code == 'AAE'" class="mb-3">
                  <strong>{{ $t("transcript.aaeRemarksTerm") }}</strong>
                </div>

                <div class="table-responsive">
                  <table class="table">
                    <thead>
                      <tr>
                        <th>{{ $t("transcript.code") }}</th>
                        <th>{{ $t("transcript.course") }}</th>
                        <th class="text-center">
                          {{ $t("transcript.percentage") }}
                        </th>
                        <th class="text-center">
                          {{ $t("transcript.grade") }}
                        </th>
                        <th
                          class="text-center"
                          v-if="program.program_code == 'DBA' || program.program_type =='CAP Program'"
                        >
                          {{ $t("transcript.sbsCredits") }}
                        </th>
                        <th class="text-center" v-else>
                          {{ $t("transcript.ectsCredits") }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(course, index) in courses" :key="index">
                        <td>{{ course.course_code }}</td>
                        <td>{{ course.course_title }}</td>
                        <td class="text-center">{{ course.percentage }}</td>
                        <td align="left" style="padding-left: 4%">
                          {{ course.descriptive_grade }}
                        </td>
                        <td
                          class="text-center"
                          v-if="program.program_code == 'DBA' || program.program_type =='CAP Program'"
                        >
                          {{ course.sbs_credits }}
                        </td>
                        <td class="text-center" v-else>
                          {{ course.ects_credits }}
                        </td>
                      </tr>
                    </tbody>
                    <tfoot>
                      <tr v-if="secondary_courses.length">
                        <th colspan="4"></th>
                        <th
                          class="pl-4"
                          style="min-width: 100px"
                          v-if="program.program_code == 'DBA' || program.program_type =='CAP Program'"
                        >
                          {{ $t("transcript.total") }}
                          <span class="font-weight-normal">{{
                            sbs_credits
                          }}</span>
                        </th>
                        <th class="pl-4" style="min-width: 100px" v-else>
                          {{ $t("transcript.total") }}
                          <span class="font-weight-normal">{{
                            ects_credits
                          }}</span>
                        </th>
                      </tr>
                      <template v-if="!secondary_courses.length">
                        <tr>
                          <th colspan="3">
                            {{
                              $t("transcript.gradePointAverage", { gpa: gpa })
                            }}
                          </th>
                          <th
                            colspan="2"
                            style="text-align: right; padding-right: 4rem"
                            v-if="program.program_code == 'DBA' || program.program_type =='CAP Program'"
                          >
                            {{ $t("transcript.total") }}
                            <span class="font-weight-normal">{{
                              total_sbs_credits
                            }}</span>
                          </th>
                          <th
                            colspan="2"
                            style="text-align: right; padding-right: 4rem"
                            v-else
                          >
                            {{ $t("transcript.total") }}
                            <span class="font-weight-normal">{{
                              total_ects_credits
                            }}</span>
                          </th>
                        </tr>
                        <template v-if="program.program_code == 'AAE'">
                          <tr>
                            <th
                              colspan="5"
                              style="text-align: right; padding-right: 4rem"
                            >
                              {{ $t("transcript.aaeRemarksCredit") }}
                              <span class="font-weight-normal">120</span>
                            </th>
                          </tr>
                          <tr>
                            <th
                              colspan="5"
                              style="text-align: right; padding-right: 4rem"
                            >
                              {{ $t("transcript.totalECTS") }}
                              <span class="font-weight-normal">{{
                                total_ects_credits + 120
                              }}</span>
                            </th>
                          </tr>
                        </template>
                      </template>
                    </tfoot>
                  </table>
                </div>

                <bottom
                  :student="student"
                  :program="program"
                  :registrar="registrar"
                ></bottom>
              </div>
            </div>

            <div
              class="card"
              style="
                max-width: 820px;
                min-height: 760px;
                margin: 15px auto;
                padding: 100px 40px;
              "
              v-if="secondary_courses.length"
            >
              <div class="card-body">
                <top
                  :student="student"
                  :program="secondary_program"
                  :report_date="report_date"
                  :academic_year="secondary_program.academic_year"
                ></top>

                <div v-if="secondary_program.program_code == 'AAE'">
                  {{ $t("transcript.aaeRemarksTerm") }}
                </div>

                <div class="table-responsive">
                  <table class="table">
                    <thead>
                      <tr>
                        <th>{{ $t("transcript.code") }}</th>
                        <th>{{ $t("transcript.course") }}</th>
                        <th class="text-center">
                          {{ $t("transcript.percentage") }}
                        </th>
                        <th class="text-center">
                          {{ $t("transcript.grade") }}
                        </th>
                        <th
                          class="text-center"
                          v-if="program.program_code == 'DBA' || program.program_type =='CAP Program'"
                        >
                          {{ $t("transcript.sbsCredits") }}
                        </th>
                        <th class="text-center" v-else>
                          {{ $t("transcript.ectsCredits") }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(course, index) in secondary_courses"
                        :key="index"
                      >
                        <td>{{ course.course_code }}</td>
                        <td>{{ course.course_title }}</td>
                        <td class="text-center">{{ course.percentage }}</td>
                        <td class="text-center">
                          {{ course.descriptive_grade }}
                        </td>
                        <td
                          class="text-center"
                          v-if="program.program_code == 'DBA' || program.program_type =='CAP Program'"
                        >
                          {{ course.sbs_credits }}
                        </td>
                        <td class="text-center" v-else>
                          {{ course.ects_credits }}
                        </td>
                      </tr>
                    </tbody>
                    <tfoot>
                      <tr>
                        <th colspan="4"></th>
                        <th
                          class="text-center"
                          style="min-width: 100px"
                          v-if="secondary_program.program_code == 'DBA' || secondary_program.program_type =='CAP Program'"
                        >
                          {{ $t("transcript.total") }}
                          <span class="font-weight-normal">{{
                            secondary_sbs_credits
                          }}</span>
                        </th>
                        <th class="text-center" style="min-width: 100px" v-else>
                          {{ $t("transcript.total") }}
                          <span class="font-weight-normal">{{
                            secondary_ects_credits
                          }}</span>
                        </th>
                      </tr>
                      <!-- <tr v-if="secondary_program.program_code=='AAE'">
                                                <th colspan="3"></th>
                                                <th colspan="2">
                                                    {{$t('transcript.aaeRemarksCredit')}}
                                                    <span class="font-weight-normal">120</span>
                                                </th>
                                            </tr> -->
                      <tr>
                        <th colspan="3">
                          {{ $t("transcript.gradePointAverage", { gpa: gpa }) }}
                        </th>
                        <th
                          colspan="2"
                          style="min-width: 100px; text-align: center"
                          v-if="secondary_program.program_code == 'DBA' || secondary_program.program_type == 'CAP Program'"
                        >
                          {{ $t("transcript.totalSBS") }}
                          <span class="font-weight-normal">{{
                            total_sbs_credits
                          }}</span>
                        </th>
                        <th
                          colspan="2"
                          style="min-width: 100px; text-align: center"
                          v-else
                        >
                          {{ $t("transcript.totalECTS") }}
                          <span class="font-weight-normal">{{
                            total_ects_credits
                          }}</span>
                        </th>
                      </tr>
                    </tfoot>
                  </table>
                </div>

                <p>
                  <strong>{{ $t("transcript.page1") }}</strong>
                </p>

                <bottom
                  :student="student"
                  :program="program"
                  :registrar="registrar"
                ></bottom>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DownloadTranscript from "../../components/DownloadTranscript.vue";
import Top from "./_top";
import Bottom from "./_bottom";

export default {
  props: ["permissions", "dateFormat"],
  components: {
    DownloadTranscript,
    Top,
    Bottom,
  },

  data() {
    return {
      alert: false,
      alertClass: "",
      alertMessage: "",

      isLoading: false,
      fullPage: true,
      downloadBtns: false,

      program: {
        id: null,
        title: null,
        code: null,
        type: null,
        academic_year: null,
        graduate: 0,
        graduation_date: null,
      },

      secondary_program: {
        id: null,
        title: null,
        code: null,
        type: null,
        academic_year: null,
        graduate: 0,
        graduation_date: null,
      },

      student: {
        id: null,
        student_number: null,
        name: null,
        birth_date: null,
        birth_place: null,
        partner_campus_location: null,
        report_date: null,
      },

      courses: [],
      secondary_courses: [],

      report_date: null,
      registrar: null,

      sbs_credits: null,
      ects_credits: null,

      secondary_sbs_credits: null,
      secondary_ects_credits: null,

      total_sbs_credits: null,
      total_ects_credits: null,

      grades_points: null,
      gpa: null,
    };
  },

  mounted() {
    if (!this.permissions.viewStudentsTranscripts) {
      return this.$router.push("/");
    }

    this.fetch();
  },

  methods: {
    async createToken(type) {
      let response = await axios.post("/api/api-tokens", {
        type,
      });
      let token = "";

      if (response.status == 200) {
        token = response.data.extra[0].token;
      }

      return token;
    },

    async generate(type) {
      let token = await this.createToken("transcript");
      if (token == "") return;

      window.open(
        `/transcripts/${this.$route.params.id}/${type}?m=full&token=${token}`,
        "_blank"
      );
    },

    fetch() {
      this.isLoading = true;

      axios
        .get(`/api/transcripts/${this.$route.params.id}/full`)
        .then((response) => {
          let data = response.data;

          this.program = data.program;
          this.secondary_program = data.secondary_program;
          this.student = data.student;
          this.courses = data.courses;
          this.secondary_courses = data.secondary_courses;
          this.registrar = data.registrar;
          this.report_date = data.report_date;

          this.sbs_credits = data.sbs_credits;
          this.ects_credits = data.ects_credits;

          this.secondary_sbs_credits = data.secondary_sbs_credits;
          this.secondary_ects_credits = data.secondary_ects_credits;

          this.total_sbs_credits = data.total_sbs_credits;
          this.total_ects_credits = data.total_ects_credits;

          this.grades_points = data.grades_points;
          this.gpa = data.gpa;

          this.downloadBtns = true;
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("error fetching transcript record");

          this.isLoading = false;
        });
    },

    /**
     * Show alert on the page
     *
     * @params string message
     * @params string class
     *
     */
    showAlert(message, alertClass = "success") {
      this.alertMessage = message;
      this.alertClass = alertClass;
      this.alert = true;
    },
  },
};
</script>


<style lang="scss" scoped>
.content table#student-detials-table th,
.content table#student-detials-table td {
  border: 0;
}
</style>
